import { useQuery } from '@tanstack/react-query';
import { Uid } from 'src/types/dto';

import { getEvent } from './api';

export const useEventQuery = (id: Uid, ref: string) => {
  return useQuery({
    queryKey: ['event', id],
    queryFn: () => {
      const params: any = {};
      if (ref) {
        params.ref = ref;  // Adiciona 'ref' ao params apenas se houver valor
      }
      return getEvent({ eventId: id, params });
    },  
  });
};
